import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ca-status-chip',
  templateUrl: 'status-chip.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaStatusChipComponent {
  @Input()
  status: 'success' | 'error' | 'warning';
}
